export default "__VITE_ASSET__1fA3Rew3__"